import http from '@/http'

export const requestCannyWidgetToken = async (): Promise<string> => {
  return http.get(`auth/canny-token`)
    .then(res => res.data)
}
